import { isEmpty } from 'shared/lib/object/object';

// TODO: Improve this to look more like the text search mechanism of DGraph
const containsAll = (value, searchText) => {
  const tokens = searchText.toLowerCase().split(' ');
  const lcValue = value.toLowerCase();
  for (let i = 0; i < tokens.length; i++) {
    if (lcValue.search(tokens[i]) === -1) {
      return false;
    }
  }
  return true;
};

export const textFn = ({ propertyValues, scope }) => {
  const neededValue = scope.text;

  const value = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.text;
  if (value === undefined) {
    return false;
  }

  if (scope.isEmpty) {
    return isEmpty(value);
  }

  return containsAll(value, neededValue);
};

export const directTextFn = ({ entity, scope }) => {
  const neededValue = scope.text;

  const value = entity[scope.directProperty.edgeName];
  if (value === undefined) {
    return false;
  }
  if (scope.isEmpty) {
    return isEmpty(value);
  }

  return containsAll(value, neededValue);
};
